import produce from "immer";
import { without } from "lodash";
import create from "zustand";
import { persist } from "zustand/middleware";
import { isActiveTransmitScaleMemoized } from "./memoizedMethods";

type TransmitScaleConfigState = {
  disabledIds: string[];
  setDisabledIds: (ids: string[]) => void;
  setActiveIds: (ids: string[]) => void;
  forcedInteractiveIds: string[];
  toggleIsActive: (id: string) => void;
  toggleForceInteractivity: (id: string) => void;
};

const useTransmitScaleConfig = create<TransmitScaleConfigState>(
  persist(
    (set, get) => ({
      disabledIds: [],
      setDisabledIds: (ids) =>
        set((state) =>
          produce(state, (draft) => {
            const idsToInclude = ids.filter(
              (id) => !state.disabledIds.includes(id)
            );
            draft.disabledIds = [...state.disabledIds, ...idsToInclude];
          })
        ),
      setActiveIds: (ids) =>
        set((state) =>
          produce(state, (draft) => {
            draft.disabledIds = state.disabledIds.filter(
              (id) => !ids.includes(id)
            );
          })
        ),
      forcedInteractiveIds: [],
      toggleIsActive: (id) =>
        set((state) => {
          const includesId = state.disabledIds.includes(id);

          isActiveTransmitScaleMemoized(id, includesId);

          return {
            disabledIds: includesId
              ? without(state.disabledIds, id)
              : [...state.disabledIds, id]
          };
        }),
      toggleForceInteractivity: (id) =>
        set((state) => ({
          forcedInteractiveIds: state.forcedInteractiveIds.includes(id)
            ? without(state.forcedInteractiveIds, id)
            : [...state.forcedInteractiveIds, id]
        }))
    }),
    {
      name: "reward-scaling-config",
      version: 3
    }
  )
);

export default useTransmitScaleConfig;
